import type { VfConfig } from '#types/config/components/vf'

export default {
  brandClasses: {
    searchBar: '[&_input]:(c-current placeholder-current) <lg:(px-3 py-2 bg-white)',
    suggestions: {
      wrapper: 'w-full transition-opacity overflow-auto lg:(mt-2 w-208)'
    }
  }
} satisfies VfConfig['search']
